import React, { useState, useEffect } from 'react';
import { updateLead } from '../../services/AdminLeadService';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClose } from '@fortawesome/free-solid-svg-icons';
import LeadEditForm from '../../forms/leads/LeadEditForm';
import '../../styles/AdminModal.css';

const LeadEditModal = ({
  isOpen,
  onClose,
  onSuccess,
  lead,
  boats
}) => {
  const [formData, setFormData] = useState({
    fullName: '',
    email: '',
    phone: '',
    date: '',
    message: '',
    boat: null,
  });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const isFormValid =
    formData.fullName.trim() !== '' &&
    formData.email.trim() !== '' &&
    formData.phone.trim() !== '';

  const hasChanges =
    lead &&
    (lead.full_name !== formData.fullName ||
      lead.email !== formData.email ||
      lead.phone !== formData.phone ||
      lead.date !== formData.date ||
      lead.message !== formData.message ||
      JSON.stringify(lead.boat) !== JSON.stringify(formData.boat)
      );

  useEffect(() => {
    if (lead) {
      setFormData({
        fullName: lead.full_name || '',
        email: lead.email || '',
        phone: lead.phone || '',
        date: lead.date || '',
        message: lead.message || '',
        boat: lead.boat || null,
      });
      setErrors({});
    }
  }, [lead]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === 'boat_id') {
      const selectedBoat = boats.find(boat => boat.id === parseInt(value));
      setFormData({
        ...formData,
        boat: selectedBoat || null,
      });
    } else {
      setFormData({
        ...formData,
        [name]: value,
      });
    }
  };

  const handleSave = async () => {
    setLoading(true);
    setErrors({});
    setError('');
    try {
      const dataToSave = {
        full_name: formData.fullName,
        email: formData.email,
        phone: formData.phone,
        date: formData.date || null,
        message: formData.message || null,
        boat: formData.boat?.id || null,
      };
      await updateLead(lead.id, dataToSave);
      await onSuccess();
    } catch (error) {
      if (error.response && error.response.data) {
        setError(error.response.data.error || 'Error updating lead. Please try again.');
      } else {
        setError('Error updating lead. Please try again.');
      }
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="admin__modal">
      <div className="admin__modal-content">
        <div className="admin__modal-intro">
          <h2>Edit Lead</h2>
          <button className="admin__modal-close" onClick={onClose}>
            <FontAwesomeIcon icon={faClose} />
          </button>
        </div>
        {error && <div className="error-message">{error}</div>}
        <div className="admin__modal-body">
          <LeadEditForm
            formData={formData}
            errors={errors}
            handleChange={handleChange}
            boats={boats}
          />
        </div>
        <div className="admin__modal-buttons">
          <button className="button secondary" onClick={onClose} disabled={loading}>
            {loading ? 'Saving...' : 'Cancel'}
          </button>
          <button className="button" onClick={handleSave} disabled={loading || !isFormValid || !hasChanges}>
            {loading ? 'Saving...' : 'Save'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default LeadEditModal;